import React, {useState} from "react";
import {css} from "@emotion/react";

import {borderRadius, calculateRemSize, mb, pointer} from "@pg-design/helpers-css";

import {IReelListItem} from "../../../types/IReelListItem";
import {IReelSize} from "../../../types/IReelSize";
import {getListReelCoverImgBySize} from "../../../utils/get_list_reel_cover_img_by_size";
import {ReelPlayButtonCover} from "../../details/reel_details_parts/ReelPlayButtonCover";
import {ReelAuthorLogo} from "./ReelAuthorLogo";
import {ReelAuthorName} from "./ReelAuthorName";
import {ReelBox} from "./ReelBox";
import {ReelDescription} from "./ReelDescription";
import {ReelImgCover} from "./ReelImgCover";

interface IProps {
    reelData: IReelListItem;
    size: IReelSize;
    onClick?: (reel: IReelListItem) => void;
    className?: string;
    forceHover?: boolean;
}

export const Reel = (props: IProps) => {
    const {reelData, size} = props;
    const coverImgSrc = getListReelCoverImgBySize(reelData.cover, size);
    const [isHovered, setIsHovered] = useState(false);

    const handleReelClick = () => {
        props.onClick?.(props.reelData);
    };

    return (
        <ReelBox
            cover={
                <div>
                    <ReelImgCover imageUrl={coverImgSrc} />
                    <div css={[reelVideoCoverWrapperStyle, (isHovered || props?.forceHover) && reelVideoCoverWrapperHoveredStyle]}>
                        {(isHovered || props?.forceHover) && <ReelPlayButtonCover />}
                    </div>
                </div>
            }
            logo={<ReelAuthorLogo size={props.size} autorInfo={reelData.creator.name} logoSrc={reelData.creator.image.r_c_img_48x48} css={reelLogoStyle} />}
            size={props.size}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleReelClick}
            css={[reelWrapperStyle, pointer]}
            className={props.className}
        >
            <ReelAuthorName size={props.size} css={mb(0.5)}>
                {reelData.creator.name}
            </ReelAuthorName>
            <ReelDescription size={props.size}>{reelData.title}</ReelDescription>
        </ReelBox>
    );
};

const reelWrapperStyle = css`
    transition: all 0.3s ease;

    &:hover {
        ${borderRadius(1)};
    }
`;

const reelVideoCoverWrapperStyle = css`
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 1s ease;
`;

const reelVideoCoverWrapperHoveredStyle = css`
    opacity: 1;
`;

const reelLogoStyle = css`
    position: absolute;
    top: ${calculateRemSize(1)};
    right: ${calculateRemSize(1)};
`;
import React, {useState} from "react";
import {css} from "@emotion/react";

import {borderRadius, calculateRemSize, mb, pointer} from "@pg-design/helpers-css";

import {IReelListItem} from "../../../types/IReelListItem";
import {IReelSize} from "../../../types/IReelSize";
import {getListReelCoverImgBySize} from "../../../utils/get_list_reel_cover_img_by_size";
import {ReelPlayButtonCover} from "../../details/reel_details_parts/ReelPlayButtonCover";
import {ReelAuthorLogo} from "./ReelAuthorLogo";
import {ReelAuthorName} from "./ReelAuthorName";
import {ReelBox} from "./ReelBox";
import {ReelDescription} from "./ReelDescription";
import {ReelImgCover} from "./ReelImgCover";

interface IProps {
    reelData: IReelListItem;
    size: IReelSize;
    onClick?: (reel: IReelListItem) => void;
    className?: string;
    forceHover?: boolean;
}

export const Reel = (props: IProps) => {
    const {reelData, size} = props;
    const coverImgSrc = getListReelCoverImgBySize(reelData.cover, size);
    const [isHovered, setIsHovered] = useState(false);

    const handleReelClick = () => {
        props.onClick?.(props.reelData);
    };

    return (
        <ReelBox
            cover={
                <div>
                    <ReelImgCover imageUrl={coverImgSrc} />
                    <div css={[reelVideoCoverWrapperStyle, (isHovered || props?.forceHover) && reelVideoCoverWrapperHoveredStyle]}>
                        {(isHovered || props?.forceHover) && <ReelPlayButtonCover />}
                    </div>
                </div>
            }
            logo={<ReelAuthorLogo size={props.size} autorInfo={reelData.creator.name} logoSrc={reelData.creator.image.r_c_img_48x48} css={reelLogoStyle} />}
            size={props.size}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleReelClick}
            css={[reelWrapperStyle, pointer]}
            className={props.className}
        >
            <ReelAuthorName size={props.size} css={mb(0.5)}>
                {reelData.creator.name}
            </ReelAuthorName>
            <ReelDescription size={props.size}>{reelData.title}</ReelDescription>
        </ReelBox>
    );
};

const reelWrapperStyle = css`
    transition: all 0.3s ease;

    &:hover {
        ${borderRadius(1)};
    }
`;

const reelVideoCoverWrapperStyle = css`
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 1s ease;
`;

const reelVideoCoverWrapperHoveredStyle = css`
    opacity: 1;
`;

const reelLogoStyle = css`
    position: absolute;
    top: ${calculateRemSize(1)};
    right: ${calculateRemSize(1)};
`;
